<template>
  <div class="mx-auto nf_container">
    <div class="nf_preview">
      <img src="/image/404-preview.png" alt="" />
    </div>
    <div class="nf_content">
      <div class="nf_heading">
        {{ $t("errors.404.title") }}
      </div>
      <div class="nf_descr">
        {{ $t("errors.404.description") }}
      </div>
      <router-link :to="{ name: 'home.index' }">
        <BaseButton size="md" variant="primary" color="green"
        >{{ $t("buttons.back_to_home") }}
        </BaseButton
        >
      </router-link>
    </div>
  </div>
</template>
